import React from 'react';
import './SecuritySection.css';

const features = [
  {
    title: "Encryption at rest & in transit",
    desc: "Secure transport and storage for your data and chat logs.",
    icon: "https://cdn-icons-png.flaticon.com/512/1121/1121081.png"
  },
  {
    title: "Workspace isolation",
    desc: "Data is separated per organization to prevent cross-tenant access.",
    icon: "https://cdn-icons-png.flaticon.com/512/6596/6596115.png"
  },
  {
    title: "Audit visibility",
    desc: "Activity is recorded so you can review key actions when needed.",
    icon: "https://cdn-icons-png.flaticon.com/512/1828/1828911.png"
  },
  {
    title: "Sensitive data masking",
    desc: "Reduce exposure by redacting confidential information.",
    icon: "https://cdn-icons-png.flaticon.com/512/1239/1239715.png"
  },
  {
    title: "Custom retention controls",
    desc: "Choose how long chats and content should be stored.",
    icon: "https://cdn-icons-png.flaticon.com/512/3208/3208753.png"
  },
  {
    title: "Zero-retention LLM option",
    desc: "Use models where input data isn’t used to retrain.",
    icon: "https://cdn-icons-png.flaticon.com/512/3064/3064197.png"
  }
];

const SecuritySection = () => {
  return (
    <section className="security-section">
      <h2 className="security-heading">
        <span className="ia-titleGradient">Security built in</span>, Your data stays yours.
      </h2>
      <p className="security-subtext">
        We use strong protections to safeguard your content and conversations, with controls designed for real teams.
      </p>
      <a href="#" className="trust-center-link">Visit The Trust Center →</a>

      <div className="security-grid">
        {features.map((item, idx) => (
          <div className="security-card" key={idx}>
            <img src={item.icon} alt="icon" />
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SecuritySection;
